export default __webpack_public_path__ + "static/media/info-icon.7d2a9c5f.svg";